import { signup } from "./signup.service";

export const signupService = { signup };
